interface HalfCircleProps {
  className?: string;
}

export function HalfCircle({ className = "w-6 h-6" }: HalfCircleProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Filled left half */}
      <path
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10V2Z"
        fill="currentColor"
        opacity="0.9"
      />
      {/* Outline right half */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  );
}
